export const createIncaFormContext = (options)=>{
    return {
        type: 'form',
        ...options
    };
};
export const createStartPageContext = (options)=>{
    const { startPageId, currentUser } = options;
    return {
        type: 'startpage',
        currentUser,
        startPage: {
            id: startPageId
        }
    };
};
export const createCustomPageContext = (options)=>{
    const { shortname, currentUser } = options;
    return {
        type: 'custompage',
        currentUser,
        customPage: {
            shortname
        }
    };
};
